export enum TableActions {
    // Grid row actions
    circleDirections = 'circleDirections',
    info = 'info',
    copy = 'copy',
    edit = 'edit',
    remove = 'remove',
    file = 'file',
    id = 'id',
    message = 'message',
    comment = 'comment',
    details = 'details'
}